module.exports = __webpack_public_path__ + "static/media/emailIcon.a9d17f61.svg";